import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import EnrollmentListFooter from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentListFooter';
import EnrollmentsListFilterSection from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentsListFilterSection';
import SuccessfulEnrollmentsContent from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/SuccessfulEnrollmentsContent';
import SkippedEnrollmentsContent from 'automation-ui-canvas/containers/enrollment-history/panel/skipped-enrollments-list/SkippedEnrollmentsContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollmentsListPanelContent = ({
  flow,
  isHybrid,
  subScreen
}) => {
  const isSkippedEnrollmentsScreen = subScreen === 'skipped';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIPanelBody, {
      children: [/*#__PURE__*/_jsx(EnrollmentsListFilterSection, {
        flow: flow,
        isHybrid: isHybrid,
        isSkippedEnrollmentsScreen: isSkippedEnrollmentsScreen
      }), isSkippedEnrollmentsScreen ? /*#__PURE__*/_jsx(SkippedEnrollmentsContent, {
        flow: flow,
        isHybrid: isHybrid
      }) : /*#__PURE__*/_jsx(SuccessfulEnrollmentsContent, {
        flow: flow,
        isHybrid: isHybrid
      })]
    }), isSkippedEnrollmentsScreen && /*#__PURE__*/_jsx(EnrollmentListFooter, {
      flowId: flow.flowId
    })]
  });
};
export default EnrollmentsListPanelContent;